import React, { forwardRef, useMemo } from 'react'
import { getValue } from 'firebase-utils'
import { PageHeader } from 'functional-foundations'
import useRouteState from '../../hooks/useRouteState'

interface PropsInterface {
    onClickBack?: () => unknown
    brands: unknown[]
    campaigns: unknown[]
    campaignsWithNumber: unknown[]
}

/**
 *
 */
const Header = forwardRef<HTMLDivElement, PropsInterface>(({
    onClickBack,
    brands,
    campaigns,
    campaignsWithNumber
}, ref): JSX.Element => {
    const { activePage, currentTab } = useRouteState()

    const showBackButton = useMemo(() => {
        if (activePage === 'create') {
            if (currentTab === 'brands' && brands.length) {
                return true
            }

            if (currentTab === 'campaigns' && campaigns.length) {
                return true
            }

            if (currentTab === 'number-assignement' && campaignsWithNumber.length) {
                return true
            }
        }

        if (activePage === 'edit') {
            return true
        }

        if (activePage === 'preview') {
            return true
        }

        return false
    }, [activePage, currentTab, brands.length, campaigns.length, campaignsWithNumber.length])

    const text = useMemo(() => {
        if (showBackButton) {
            if (activePage === 'create') {
                if (currentTab === 'brands') {
                    return getValue('sms_enrollment_add_brand_button')
                }
                if (currentTab === 'campaigns') {
                    return getValue('sms_enrollment_add_new_campaign')
                }
                if (currentTab === 'number-assignement') {
                    return getValue('sms_enrollment_add_new_number')
                }
            }

            if (activePage === 'edit') {
                return 'Review and Edit'
            }
        }
        return getValue('sms_registration_title')
    }, [showBackButton, activePage])

    return <PageHeader ref={ref} onClickBack={showBackButton ? onClickBack : undefined}>
        {text}
    </PageHeader>
})

Header.displayName = 'Header'

export default Header
